import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { combineLatest, Observable, of } from 'rxjs';
import { catchError, filter, switchMap, take, tap } from 'rxjs/operators';

import * as fromStore from 'src/app/store';

export const PaymentsGuard = (): Observable<boolean> => {
  const store = inject(Store<fromStore.State>);

  const checkStore = (): Observable<boolean> =>
    combineLatest([
      store.select(fromStore.getPaymentsLoaded),
      store.select(fromStore.getPaymentsLoading),
    ]).pipe(
      tap(([loaded, loading]) => {
        if (!loaded && !loading) {
          store.dispatch(new fromStore.LoadPayments());
        }
      }),
      filter(([loaded, loading]) => loaded || !loading),
      take(1),
      switchMap(() => of(true)),
    );

  return checkStore().pipe(catchError(() => of(true)));
};
